module.exports = __webpack_public_path__ + "assets/img/button-start.9e97f2d1.png";